<template>
  <div class="layout-header">
    <div class="logo-title">
      <div class="logo-title_nav" id="moduleRnter" @click="handleOpenMenu">
        <i class="iconfont icon-gongnengliebiao"></i>
      </div>
      <img class="logo" src="/static/img/logo.png" @click="$router.push('/console')"/>
      <div class="iJournal" v-if="$route.path.indexOf('/xueshi-iJournal') === 0">
        <img class="iJournal_logo" src="../../../assets/iJournal_logo.png" @click="setiframeSrc"/>
      </div>
    </div>
    <div class="nav" >
      <router-link tag="div" to="/message" class="nav_item text_color_primary">
        <el-badge :value="messageCount" type="danger" :hidden="messageCount === 0">
          <p class="text_size_14">消息</p>
        </el-badge>
      </router-link>
      <avatar id="message" :avatarInfo="avatarInfo" />
    </div>
  </div>
</template>

<script>
import { xueshiHomePath } from '~/utils/assist'
import avatar from './avatar'
import * as api from '~/api'
export default {
  data () {
    return {
      // 消息数量
      messageCount: 0
    }
  },
  props: {
    isOpenLeftMenu: {
      type: Boolean,
      default: false
    },
    // 用户的个人信息
    avatarInfo: {
      type: Object,
      default: () => {
        return ({})
      }
    }
  },
  computed: {
    $_isOpenLeftMenu: {
      get () {
        return this.isOpenLeftMenu
      },
      set (val) {
        this.$emit('update:isOpenLeftMenu', val)
      }
    }
  },
  components: {
    avatar
  },
  mounted () {
    // 获取消息数量
    this.getCount()

    let interval = this.$store.state.interval
    if (interval) {
      clearInterval(interval)
    }
    interval = setInterval(() => {
      this.getCount()
    }, 60000)
    this.$store.commit('updateInterval', interval)
  },
  methods: {
    // 去首页
    toHomePage () {
      location.href = xueshiHomePath
    },
    // 设置期刊iframeSrc
    setiframeSrc () {
      this.$bus.emit('setiframeSrc', { src: '/xueshi-iJournal/home' })
    },
    // 获取消息数量
    getCount () {
      api.getUnreadMessageCount().then(res => {
        let data = res.data
        if (data.code === 0) {
          if (data.data.count <= 99) {
            this.messageCount = data.data.count
          } else {
            this.messageCount = '99+'
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 开关侧边栏
    handleOpenMenu () {
      this.$_isOpenLeftMenu = !this.$_isOpenLeftMenu
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-header {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1995;
  width: 100%;
  min-width: 800px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: $layout-header-height;
  text-align: center;
  background-color: #fff;
  box-shadow:0px 0px 10px 0px rgba(53,53,53,0.15);
  .logo-title {
    display: flex;
    align-items: center;
    height: 100%;
    &_nav {
      width: 50px;
      height: 50px;
      background-color: #3485FB;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      & > i {
        color: #fff;
      }
      &:hover {
        background-color: $--color-primary-light-2;
      }
    }
    .logo {
      width: 137px;
      height: 100%;
      padding: 15px 20px;
      &:hover {
        background-color: $--color-primary-light-9;
        cursor: pointer;
      }
    }
    .console_title {
      display: flex;
      align-items: center;
      height: 100%;
      padding: 0 30px;
    }
  }
  .nav {
    display: flex;
    align-items: center;
    height: 100%;
    &_item {
      display: flex;
      align-items: center;
      padding: 0 30px;
      height: 100%;
      p {
        padding: 0 6px;
      }
      &:hover {
        background-color: $--color-primary-light-9;
        cursor: pointer;
      }
    }
    &_search {
      padding: 0 30px;
    }
    &_input {
      height: 100%;
      width: 200px;
      margin: 0;
    }
  }
}
.iJournal {
  position: relative;
  justify-self: flex-start;
  display: flex;
  align-items: center;
  padding: 0 12px;
  height: 100%;
  &::before {
    content: "";
    width: 0px;
    height: 24px;
    border-left: 1px solid #C0C4CC;
    position: absolute;
    left: 0;
  }
  &:hover {
    cursor: pointer;
    background-color: $--color-primary-light-9;
  }
  &_logo {
    width: 113.46px;
    height: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/header/index.vue